import MonoBehavior from "../lib/MonoBehavior";
import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import { clamp01 } from "../util";
import Color from "../util/Color";
import Player from "./Player";
import SPPlayer from "./SPPlayer";

export default class SPHealingFieldBehavior extends MonoBehavior {
    born = Time.time;
    size = 256;
    lifetime = 3;
    rings: number[] = [1];
    ringTimer = 1;

    get timeAlive() {return Time.time-this.born;}

    Die() {
        this.engine.RemoveGameObject(this.gameObject);
    }

    Update(): void {
        if (this.timeAlive >= this.lifetime) {
            this.Die();
        }

        if (this.ringTimer > 0) {
            this.ringTimer -= Time.deltaTime;

            if (this.ringTimer <= 0) {
                this.rings.push(1);
                this.ringTimer = 1;
            }
        }

        if (Physics.CircleCircleCollision({
            position: this.transform.position,
            radius: this.size
        }, {
            position: SPPlayer.Singleton.transform.position,
            radius: SPPlayer.Singleton.size
        }) !== false) {
            SPPlayer.Singleton.hp += 0.5 * Time.deltaTime;
            if (SPPlayer.Singleton.hp > SPPlayer.Singleton.maxHP) SPPlayer.Singleton.hp = SPPlayer.Singleton.maxHP;
        }

        for (let i = this.rings.length - 1; i >= 0; i--) {
            this.rings[i] += 128 * Time.deltaTime;

            if (this.rings[i] >= this.size) {
                this.rings.splice(i, 1);
            }
        }
    }

    Draw(): void {
        const color = new Color(80,255,80);
        this.ctx.strokeStyle = color.toHexWithAlpha(0.1);
        this.ctx.lineWidth = 1;
        this.engine.StrokeCircle(this.transform.position, this.size);

        for (const ring of this.rings) {
            const a = clamp01(1 - ring/this.size);
            this.ctx.strokeStyle = color.toHexWithAlpha(a);
            this.engine.StrokeCircle(this.transform.position, ring);
        }
    }
}